import React, { useEffect, useRef, useState } from 'react';
import Button from '../../Atoms/Button/Button';
import Image from '../../Atoms/Image/Image';
import HamBurger from '../../../assets/RemoteOrder/icons/nav-menu.svg';
import Close from '../../../assets/RemoteOrder/icons/close-ham.svg';
import UseWindowWidth from '../../../hooks/useWindowWidth';
import './NavBar.scss';
import classNames from 'classnames';
import useRequest from '../../../hooks/useRequest';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import useStore from '../../../store/useStore';
import Heading from '../../Atoms/Heading/Heading';
import { addFocusListener, filterItems, removeFocusListener } from '../../../Utils/componentUtils';
import Link from '../../Atoms/Link/Link';
import { getLocalTime } from '../../../Utils/analyticsUtils';
import _isEqual from 'lodash/isEqual';
import {
  BANNER_ACTIONNAME,
  BANNER_NOTIFICATION,
  FOOTER,
  HEADER,
  MENU,
  ORDER_CONFIRMATION,
  START_ORDER,
  SUBWAY_LOGO,
  VIEW_BAG,
} from '../../../constants/AnalyticsConstants';
import { excludedPagesAnalytics } from '../../../constants/App';
import { getPageName } from '../../../Utils/pageUtils';
import CartProgressBar from '../../Atoms/CartProgressBar/CartProgressBar';
import { componentRenderCheck, multipleAndCheck, multipleOrCheck, ternaryCheck } from '../../../Utils/WindowUtils';


interface MenuBarProps {
  apiEndpoint: any;
  dataSource: string;
  orderViewModel: any;
  siteName: string;
  engageApptentiveEvent: any;
  analytics: any;
}
const NavBar: React.FC<MenuBarProps> = ({
  apiEndpoint,
  dataSource,
  orderViewModel,
  siteName,
  engageApptentiveEvent,
  analytics,
}) => {
  const [isMenuVisible, setIsMenuVisible] = React.useState<boolean>(false);
  const windowsWidth =ternaryCheck(UseWindowWidth() <= 1024 , true , false);
  const isLoggedIn = useStore((state: any) => state.isLoggedIn);
  const { cartQuantity, setHeaderHeight, pageDisplayName } = useStore();
  const [navigationSectionItems, setNavigationSectionItems] = React.useState<any>([]);
  const [offerList, setOfferList] = React.useState<any>({});
  const [headerResponse, setHeaderResponse] = React.useState<any>([]);
  const header = document.querySelector('.navbar');
  const headerHeight = _get(header, ['offsetHeight'], 0);
  const header2 = document.querySelector('.defaultHeader__comp');
  const headerHeight2 = _get(header2, ['offsetHeight'], 0);
  const { setAnalyticsProducts, setAttemptTracker, setHeaderLoad } = useStore();
  const buttonRef = useRef<HTMLDivElement>(null);
  const firstFocusableElementRef = useRef<any>(null);
  const lastFocusableElementRef = useRef<any>(null);
  const [isShowCartProgressBar, setIsShowCartProgressBar] = useState(false);
  const [fetchCartProgressItems, setFetchCartProgressItems] = React.useState<any>([]);

  const matchUrlData = (values: any) => {
    const pathSegments = window.location.pathname.split('/');

    return values.some((value: string) => {
      return pathSegments.includes(value);
    });
  };

  const pagesList = [
    ORDER_CONFIRMATION,
    'paymentmethods',
    'contactinfo',
    'recent-orders',
    'my-favorites',
    'rewards-activity',
    'requestmissingpoints',
  ];
  React.useEffect(() => {
    setHeaderHeight(parseInt(headerHeight) + parseInt(headerHeight2) + 'px');
  }, [headerHeight, headerHeight2]);

  const { data, getRequest } = useRequest({
    params: {
      apiEndpoint: apiEndpoint.value,
      DatasourceId: dataSource,
      sitename: siteName,
    },
  });

  React.useEffect(() => {
    if (data) {
      if (data.redDotAPI) {
        getRequest({
          apiEndpoint: data.redDotAPI,
          currentSite: siteName,
          pageId: (window as any).currentItemID,
          userBrowserTime: getLocalTime(),
        });
      }

      if (data.offerList) {
        setOfferList(data.offerList);
      }

      if (data.globalHeader) {
        setHeaderLoad(true);
        setHeaderResponse(data);
      }
    }
  }, [data]);

  React.useEffect(() => {
    if(multipleAndCheck(orderViewModel, orderViewModel.showRedirectSuccessBanner, pageDisplayName === MENU)) {
      localStorage.setItem('cartProgressBar', "1");
    }
  },[])

  React.useEffect(() => {
    const items = filterItems(
      _get(headerResponse, ['rightSide', '0', 'navigationSectionItems'], []),
      isLoggedIn,
      cartQuantity,
    );

    setFetchCartProgressItems(items);
    setTimeout(() => {
      setNavigationSectionItems(items);
    }, 2000);

  }, [cartQuantity, data]);

  const handleHamBurgerClick = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const handleRedirection = (
    link: string,
    analyticsText: string,
    event: React.SyntheticEvent<EventTarget>,
  ) => {
    const pageName = getPageName();
    if (excludedPagesAnalytics.includes(pageName)) {
      analytics.cmsClickTrack('header', analyticsText, 'start order', '', '', event);
    } else {
      setAnalyticsProducts({
        clickActionName: analyticsText,
        componentTitle:
          ternaryCheck(multipleAndCheck(multipleOrCheck(analyticsText == VIEW_BAG , analyticsText == START_ORDER) , windowsWidth)
            , FOOTER
            , HEADER),
        startonlineorder: ternaryCheck(analyticsText == START_ORDER , 1 , 0),
      });
      setAttemptTracker([
        {
          name:
            ternaryCheck(multipleAndCheck(multipleOrCheck(analyticsText == VIEW_BAG , analyticsText == START_ORDER) , windowsWidth)
            , FOOTER
            , HEADER),
          isClickable: true,
        },
      ]);
    }

    setTimeout(() => {
      engageApptentiveEvent(analyticsText, true, link);
    }, 100);
  };

  const handleSubwayLogo = (apptentiveText: string, link: string) => {
    const pageName = getPageName();
    if (excludedPagesAnalytics.includes(pageName)) {
      analytics.cardListClick(SUBWAY_LOGO, 'header:');
    } else {
      setAnalyticsProducts({
        clickActionName: SUBWAY_LOGO,
        componentTitle: HEADER,
      });
      setAttemptTracker([{ name: HEADER, isClickable: true }]);
    }
    setTimeout(() => {
      engageApptentiveEvent(apptentiveText, true, link);
    }, 100);
  };
  const handleNavItem = (analyticsText: string, href: string) => {
    const pageName = getPageName();
    if (excludedPagesAnalytics.includes(pageName)) {
      analytics.cardListClick(analyticsText, 'header:');
    } else {
      setAnalyticsProducts({
        clickActionName: analyticsText,
        componentTitle: HEADER,
      });
      setAttemptTracker([{ name: HEADER, isClickable: true }]);
    }
    engageApptentiveEvent(analyticsText, true, href);
  };

  const startOrder = () => {
    let text;
    const navigation = _get(headerResponse, ['rightSide', '0', 'navigationSectionItems'], []);
    if (multipleAndCheck(!_isEmpty(orderViewModel?.selectedStoreId) , orderViewModel?.storeStatus)) {
      text = {
        text: navigation[0].title,
        link:
          window.subwayScript.navigation.getLanguageCode() +
          '/restaurant/' +
          window.subwayScript.checkSatelliteNumber(orderViewModel.selectedStoreId) +
          '/menu',
        analyticsText: navigation[0].analyticsText,
      };
    } else {
      text = {
        text: navigation[0].title,
        link: navigation[0].href,
        analyticsText: navigation[0].analyticsText,
      };
    }

    return text;
  };
  const handleCartProgressBar = () => {
    setTimeout(() => {
      setIsShowCartProgressBar(false);
      orderViewModel.showRedirectSuccessBanner = false;
      orderViewModel.redirectBannerMessage = '';
      orderViewModel.save();
    }, 5000);
    setAnalyticsProducts({
      bannerMessage: ternaryCheck(orderViewModel.showRedirectSuccessBanner, orderViewModel.redirectBannerMessage, addToBagText),
      bannerMessageEvent: 1,
      componentTitle: HEADER,
      clickActionName: BANNER_ACTIONNAME,
    });
    setAttemptTracker([{ name: BANNER_NOTIFICATION }]);
  }
  const cartCount = localStorage.getItem('cartProgressBar');
  if (multipleAndCheck(cartCount != null , !isShowCartProgressBar)) {
    setTimeout(() => {
      setIsShowCartProgressBar(true);
    }, 500)
  }
  const pages = ['menu', 'recent-orders', 'my-favorites', 'products', 'rewards-activity'];
  const isNonPdpPage = multipleOrCheck(pages?.includes(pageDisplayName) , pages?.includes(getPageName()));
  const iscartPage = pageDisplayName == 'order-management';
  const viewBagText = fetchCartProgressItems && fetchCartProgressItems[1]?.viewBag;
  const addToBagText = orderViewModel.showRedirectSuccessBanner ? orderViewModel.redirectBannerMessage : fetchCartProgressItems && fetchCartProgressItems[1]?.addToBag;
  const cartfullIcon = fetchCartProgressItems && fetchCartProgressItems[1]?.imageSrc;

  useEffect(() => {
    if (isMenuVisible) {
      document.querySelector('body')?.setAttribute('aria-hidden', 'true');
      addFocusListener(buttonRef, firstFocusableElementRef, lastFocusableElementRef);
    } else {
      document.querySelector('body')?.setAttribute('aria-hidden', 'false');
      removeFocusListener();
    }
    return () => {
      document.querySelector('body')?.setAttribute('aria-hidden', 'false');
      removeFocusListener();
    };
  }, [isMenuVisible]);

  return (
    <>
      {multipleAndCheck(headerResponse , headerResponse?.globalHeader) && (
        <>
          <Link
            text={'Skip to main content'}
            data-testauto-id={'link-main-content'}
            className="skip-to-content"
            href={'#switchbodymaincontent'}
          />
          <nav className="navbar sticky-header">
            <div className="navbar__left" aria-hidden={isMenuVisible ? 'true' : 'false'}>
              {componentRenderCheck(multipleAndCheck(windowsWidth , !isMenuVisible) , (
                <Button
                  testAutoId="navbar-menu-button"
                  className="navbar__menu-button"
                  onClick={() => handleHamBurgerClick()}
                  aria-label={'menuNavigation'}
                >
                  {<HamBurger />}
                </Button>
              ))}
              {componentRenderCheck(!isMenuVisible , (
                <Button
                  className="no-border"
                  role="link"
                  testAutoId="navbar__subwayLogo"
                  onClick={() =>
                    handleSubwayLogo(
                      'Subway Logo',
                      _get(headerResponse, ['globalHeader', 'headerItem', 'href'], ''),
                    )
                  }
                >
                  <Image
                    imageSources={_get(
                      headerResponse,
                      ['globalHeader', 'headerItem', 'imageSrc'],
                      '',
                    )}
                    alt={_get(headerResponse, ['globalHeader', 'headerItem', 'alternateText'], '')}
                    className={classNames('navbar__primary-logo', {
                      'navbar__primary-logo--desktop': !windowsWidth,
                    })}
                    loadingType='eager'
                    title={_get(headerResponse, ['globalHeader', 'headerItem', 'title'], '')}
                  />
                </Button>
              ))}
              {multipleOrCheck(!windowsWidth , isMenuVisible) && (
                <div
                  className={classNames('navbar__menu-items', {
                    'navbar__menu-items--mobile': isMenuVisible,
                  })}
                  ref={buttonRef}
                >
                  {isMenuVisible && (
                    <Button
                      testAutoId="navbar-menu-button"
                      className="navbar__menu-button"
                      onClick={() => handleHamBurgerClick()}
                      aria-label={'close'}
                    >
                      {<Close />}
                    </Button>
                  )}

                  <ul className="navbar__menu-items--unorderedList">
                    {!_isEmpty(
                      _get(
                        headerResponse,
                        ['globalHeader', 'navgationItems', '0', 'navigationSectionItems'],
                        [],
                      ),
                    ) &&
                      _get(
                        headerResponse,
                        ['globalHeader', 'navgationItems', '0', 'navigationSectionItems'],
                        [],
                      ).map((item: any) => {
                        const analyticsText = _get(item, ['analyticsText'], '')
                          .replace(/\s+/g, '-')
                          .toLowerCase();
                        return (
                          <li key={item.title}>
                            <Button
                              role="link"
                              className="navbar__menu-items__menu-link"
                              title={
                                offerList[item.cssClass] && `New ${item.cssClass} are available`
                              }
                              data-testauto-id={analyticsText}
                              testAutoId={analyticsText}
                              onClick={() => handleNavItem(item.analyticsText, item.href)}
                            >
                              {item.alternateText}
                            </Button>
                            {offerList[item.cssClass] && (
                              <Heading className="red-dot" level="span" />
                            )}
                          </li>
                        );
                      })}
                  </ul>
                </div>
              )}
            </div>

            <div className="navbar__right">
              {!windowsWidth &&
                cartQuantity === 0 &&
                !_isEmpty(_get(headerResponse, ['rightSide', '0', 'navigationSectionItems'], [])) &&
                _isEqual(
                  _get(headerResponse, ['rightSide', '0', 'navigationSectionItems'], [])[0]
                    .analyticsText,
                  'Start Order',
                ) && (
                  <Button
                    role="link"
                    testAutoId={'start-order-btn'}
                    className="btn w-100 start-order"
                    data-startonlineorder={ternaryCheck(startOrder()?.analyticsText == START_ORDER , 1 , 0)}
                    onClick={event =>
                      handleRedirection(startOrder().link, startOrder().analyticsText, event)
                    }
                  >
                    {startOrder().text}
                  </Button>
                )}
              {!_isEmpty(navigationSectionItems) &&
                navigationSectionItems.map((item: any) => {
                  return (
                    item && (
                      <Button
                        key={item.title}
                        role="link"
                        aria-label={
                          ternaryCheck(multipleAndCheck(cartQuantity > 0 , item?.cssClass == 'cart_bag full')
                            , cartQuantity + ' ' + item?.adaAriaLabelText
                            , item?.adaAriaLabelText)
                        }
                        testAutoId="profile-icon"
                        className={item.cssClass + ' icons' + (cartCount ? ' fullbag_animate' : '')}
                        onClick={event => handleRedirection(item.href, item.analyticsText, event)}
                      >
                        {cartQuantity > 0 && !iscartPage && item?.cssClass == 'cart_bag full' && (
                          <Heading className={'view-bag'} level="span" title={viewBagText} />
                        )}
                        <Image imageSources={item.imageSrc} alt={''} />
                        {componentRenderCheck(multipleAndCheck(cartQuantity > 0 && item?.cssClass == 'cart_bag full') ,   (
                          <Heading className={'bag-quantity'} level="span" title={cartQuantity} />
                        ))}
                      </Button>
                    )
                  );
                })}
            </div>
            {componentRenderCheck(multipleAndCheck(isShowCartProgressBar , isNonPdpPage) , (
              <CartProgressBar addToBagText={addToBagText} cartfullIcon={cartfullIcon} handleCartProgressBar={handleCartProgressBar} />
            ))}
          </nav>

          {windowsWidth &&
            !matchUrlData(pagesList) &&
            !_isEmpty(_get(headerResponse, ['rightSide', '0', 'navigationSectionItems'], [])) &&
            _isEqual(
              _get(headerResponse, ['rightSide', '0', 'navigationSectionItems'], [])[0]
                .analyticsText,
              'Start Order',
            ) && (
              <div className="start-order-footer">
                <Button
                  role="link"
                  testAutoId={'start-order-btn'}
                  className="btn w-100 start-order"
                  data-startonlineorder={ternaryCheck(startOrder()?.analyticsText == START_ORDER , 1 , 0)}
                  onClick={event =>
                    handleRedirection(startOrder().link, startOrder().analyticsText, event)
                  }
                >
                  {startOrder().text}
                </Button>
              </div>
            )}
        </>
      )}
    </>
  );
};

export default NavBar;
